"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var insertScript = function insertScript(script, callback) {
  var s = document.createElement("script");
  s.type = "text/javascript";

  if (script.src) {
    s.onload = callback;
    s.onerror = callback;
    s.src = script.src;
  } else {
    s.textContent = script.innerText;
  }

  document.head.appendChild(s);
  script.parentNode.removeChild(script);

  if (!script.src) {
    callback();
  }
};

var _default = insertScript;
exports.default = _default;